module.exports = __webpack_public_path__ + "img/mastercard.1460a52d.png";